
import { DailySummaryItem } from './types';

const normalizeDateForTable = (d: any): any => {
  if (!d) return null;
  return d;
};


export const mapTier2ResponseToItems = (rawRows: any[] = []): DailySummaryItem[] => {
  if (!Array.isArray(rawRows)) return [];

  return rawRows.map((it: any) => {
    const date = normalizeDateForTable(it.Date ?? it.date ?? it.DateString ?? null);
    const hours = it.Hours ?? it.hours ?? null;
    const downtimePercent = it.DowntimePercentage ?? it.downtimePercent ?? it.downtimePercentage ?? null;
    const downtimeEvents = it.NoOfDowntimes ?? it.noOfDowntimes ?? it.downtimeEvents ?? null;

    // PumpChecker may include LostOil/LostGas/LostWater (often numeric or 0)
    const lostOilRaw = it.LostOil ?? it.lostOil ?? null;
    const lostGasRaw = it.LostGas ?? it.lostGas ?? null;
    const lostWaterRaw = it.LostWater ?? it.lostWater ?? null;

    const item: DailySummaryItem = {
      date,
      hours: hours != null ? Number(hours) : null,
      downtimePercent: downtimePercent != null ? Number(downtimePercent) : null,
      downtimeEvents: downtimeEvents != null ? Number(downtimeEvents) : null,
      lostOil: lostOilRaw != null && !Number.isNaN(Number(lostOilRaw)) ? Number(lostOilRaw) : null,
      lostGas: lostGasRaw != null && !Number.isNaN(Number(lostGasRaw)) ? Number(lostGasRaw) : null,
      lostWater: lostWaterRaw != null && !Number.isNaN(Number(lostWaterRaw)) ? Number(lostWaterRaw) : null,
      _raw: it,
      // ensure _tier typing matches DailySummaryItem's union (1|2|null). Use cast.
      _tier: 2 as 1 | 2 | null,
    };

    return item;
  });
};

/**
 * Map Tier1 response (asset-based wrapper) -> DailySummaryItem[]
 */
export const mapTier1ResponseToItems = (resp: any): DailySummaryItem[] => {
  if (!resp) return [];

  // caller might pass array already
  if (Array.isArray(resp)) {
    return resp.map((it: any) => ({
      date: it.date ?? it.Date ?? it.DateString ?? null,
      hours: it.hours ?? it.Hours ?? null,
      downtimePercent: it.downtimePercent ?? it.DowntimePercentage ?? null,
      downtimeEvents: it.downtimeEvents ?? it.NoOfDowntimes ?? null,
      lostOil: null,
      lostGas: null,
      lostWater: null,
      _raw: it,
      _tier: 1 as 1 | 2 | null,
    }));
  }

  const arr = resp.shutdownDailySummary ?? null;
  if (!Array.isArray(arr)) return [];

  return arr.map((it: any) => ({
    date: it.date ?? it.Date ?? it.DateString ?? null,
    hours: it.hours ?? it.Hours ?? null,
    downtimePercent: it.downtimePercent ?? it.DowntimePercentage ?? null,
    downtimeEvents: it.downtimeEvents ?? it.NoOfDowntimes ?? null,
    lostOil: null,
    lostGas: null,
    lostWater: null,
    _raw: it,
    _tier: 1 as 1 | 2 | null,
  }));
};

export default {
  mapTier2ResponseToItems,
  mapTier1ResponseToItems,
};
